import Standings from '../components/Standings';

const StandingsPage = () => (
  <section className="standings-page container container-small">
    <h2 className="standings-page">Standings</h2>
    <Standings />
  </section>
);

export default StandingsPage;
